import { MEMBER_STORAGE_KEYS, ADMIN_STORAGE_KEYS } from '../constants/storageKeys';

export function getMemberToken() {
  return localStorage.getItem(MEMBER_STORAGE_KEYS.TOKEN);
}

export function getMemberUser() {
  return parseJson(localStorage.getItem(MEMBER_STORAGE_KEYS.USER));
}

/** 前台當前登入會員 ID（強制帶入 API 用） */
export function getMemberId() {
  const user = getMemberUser();
  const id = user?.id;
  return id != null ? id : null;
}

export function getMemberPermissions() {
  return parseJson(localStorage.getItem(MEMBER_STORAGE_KEYS.PERMISSIONS)) || [];
}

export function saveMemberSession({ authToken, member, permissions }) {
  localStorage.setItem(MEMBER_STORAGE_KEYS.TOKEN, authToken);
  if (member) {
    localStorage.setItem(MEMBER_STORAGE_KEYS.USER, JSON.stringify(member));
  }
  if (permissions) {
    localStorage.setItem(
      MEMBER_STORAGE_KEYS.PERMISSIONS,
      JSON.stringify(permissions)
    );
  }
}

export function clearMemberSession() {
  localStorage.removeItem(MEMBER_STORAGE_KEYS.TOKEN);
  localStorage.removeItem(MEMBER_STORAGE_KEYS.USER);
  localStorage.removeItem(MEMBER_STORAGE_KEYS.PERMISSIONS);
}

export function getAdminToken() {
  return localStorage.getItem(ADMIN_STORAGE_KEYS.TOKEN);
}

export function getAdminUser() {
  return parseJson(localStorage.getItem(ADMIN_STORAGE_KEYS.USER));
}

export function getAdminPermissions() {
  return parseJson(localStorage.getItem(ADMIN_STORAGE_KEYS.PERMISSIONS)) || [];
}

export function getAdminRole() {
  return parseJson(localStorage.getItem(ADMIN_STORAGE_KEYS.ROLE));
}

export function saveAdminSession({ authToken, admin, permissions, role }) {
  localStorage.setItem(ADMIN_STORAGE_KEYS.TOKEN, authToken);
  if (admin) {
    localStorage.setItem(ADMIN_STORAGE_KEYS.USER, JSON.stringify(admin));
  }
  if (permissions) {
    localStorage.setItem(
      ADMIN_STORAGE_KEYS.PERMISSIONS,
      JSON.stringify(permissions)
    );
  }
  if (role) {
    localStorage.setItem(ADMIN_STORAGE_KEYS.ROLE, JSON.stringify(role));
  }
}

export function clearAdminSession() {
  localStorage.removeItem(ADMIN_STORAGE_KEYS.TOKEN);
  localStorage.removeItem(ADMIN_STORAGE_KEYS.USER);
  localStorage.removeItem(ADMIN_STORAGE_KEYS.PERMISSIONS);
  localStorage.removeItem(ADMIN_STORAGE_KEYS.ROLE);
}

function parseJson(raw) {
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
